import './App.css';
import CubeScene from './CubeScene';

function App() {
  return (
    <div className="App">
      <CubeScene />
    </div>
  );
}

export default App;
